  <!-- PARA DEBUGAR A TAG COORDENADA ALTERADA
  novaLocalizacao          : {{ novaLocalizacao?.lat }}<br/>
  endereco.geom.coord      : {{ endereco?.geom?.coordinates?.lat }}<br>
  novaLocalizacao          : {{ novaLocalizacao?.lng }}<br/>
  endereco.geom.coord      : {{ endereco?.geom?.coordinates?.lng }}<br>
  x: {{ _x() }}<br>
  y: {{ _y() }}<br>
  x+y: {{ _x() + _y() }}  -->

<div class="message-coord-nao-encontrada">
  <!-- <pre>end: {{ endereco | json }} </pre> -->

  <label
    *ngIf="!endereco?.id"
    class='tag tag-warning'
    title=''>
    Endereço não cadastrado
  </label>

  <ng-container *ngIf="endereco?.id > 0">
    <label
      *ngIf="endereco && !endereco.geom?.coordinates?.lat"
      class='tag tag-warning'
      title=''>
      Coordenada não encontrada
    </label>

    <label
      *ngIf="endereco?.geom?.coordinates?.lat && coordenadaAlterada()"
      class='tag tag-warning'
      title=''>
      Coordenada alterada
    </label>

    <label
      *ngIf="!!endereco?.geom?.coordinates?.lat && !(endereco?.geom?.coordinates?.lat && novaLocalizacao && coordenadaAlterada())"
      class='tag tag-success'
      title=''>
      Coordenadas encontradas
    </label>

    <label
      *ngIf="!f?.form?.valid"
      class='tag tag-warning'
      title=''>
      Endereço incompleto
    </label>

    <label
      *ngIf="!endereco.numero"
      class='tag tag-warning'
      title=''>
      Nº não informado
    </label>

    <label
      *ngIf="!endereco.estado || !endereco.cidade"
      class='tag tag-warning'
      title=''>
      UF/Cidade não encontrado
    </label>
  </ng-container>


</div>
